import classNames from 'classnames';
import React from 'react';

import propTypes from 'prop-types';

const FlashMessages = ({ flashMessages, makeClearForId }) => (
  <div className="FlashMessages">
    {flashMessages.map((flashMessage, index) => (
      <FlashMessage
        key={index}
        flashMessage={flashMessage}
        onClear={makeClearForId(flashMessage.id)}
      />
    ))}
  </div>
);

const FlashMessageType = propTypes.shape({
  className: propTypes.string,
  message: propTypes.string.isRequired,
});

FlashMessages.propTypes = {
  flashMessages: propTypes.arrayOf(FlashMessageType).isRequired,
  makeClearForId: propTypes.func.isRequired,
};

export const FLASH_MESSAGE_TIMEOUT = 5000;
export const FLASH_SUCCESS = 'FlashMessage--success';
export const FLASH_ERROR = 'FlashMessage--error';

class FlashMessage extends React.Component {
  static propTypes = {
    flashMessage: FlashMessageType.isRequired,
    onClear: propTypes.func.isRequired,
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        this.props.onClear();
      }, FLASH_MESSAGE_TIMEOUT);
    }
  }

  render() {
    const { className, message } = this.props.flashMessage;
    return (
      <div className={classNames('FlashMessage', className)}>{message}</div>
    );
  }
}

export default FlashMessages;
